<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style>
.errors {
  color: #970035;
}

.text-flower {
  color: #7c2362 !important;
}

.text-general_and_flower {
  color: #0060a9 !important;
}
</style>
